import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl text-sm font-medium transition-all duration-150 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 active:scale-[0.98] [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow-[3px_3px_8px_hsl(216_23%_50%/0.35),-2px_-2px_6px_hsl(0_0%_100%/0.15)] hover:shadow-[2px_2px_5px_hsl(216_23%_50%/0.35),-1px_-1px_3px_hsl(0_0%_100%/0.15)] hover:brightness-105",
        destructive:
          "bg-destructive text-destructive-foreground shadow-[3px_3px_8px_hsl(0_60%_35%/0.35),-2px_-2px_6px_hsl(0_0%_100%/0.15)] hover:brightness-105",
        outline:
          "bg-background text-foreground shadow-[inset_2px_2px_5px_hsl(var(--neo-dark)/0.3),inset_-2px_-2px_5px_hsl(var(--neo-light)/0.7)] hover:shadow-[inset_3px_3px_6px_hsl(var(--neo-dark)/0.35),inset_-3px_-3px_6px_hsl(var(--neo-light)/0.75)]",
        secondary:
          "bg-secondary text-secondary-foreground shadow-[3px_3px_8px_hsl(216_23%_50%/0.3),-2px_-2px_6px_hsl(0_0%_100%/0.1)] hover:brightness-110",
        ghost: "hover:shadow-[inset_2px_2px_5px_hsl(var(--neo-dark)/0.25),inset_-2px_-2px_5px_hsl(var(--neo-light)/0.6)]",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-lg px-3 text-xs",
        lg: "h-10 rounded-xl px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
